var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('img',{staticClass:"down-bg",attrs:{"src":require("@/assets/registeredAgent/cop-bg.png"),"alt":""}}),_c('div',{staticClass:"submit-btn anima",on:{"click":_vm.downApp}},[_vm._v("立即下载APP")])])}
var staticRenderFns = []

export { render, staticRenderFns }